export default __webpack_public_path__ + "static/media/ptx_psl_logo.ce4fe70d.png";